var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "home-page-container" }, [
    _c("div", { staticClass: "home_warp" }, [
      _c("div", { staticClass: "home_head_bg", attrs: { id: "gobk" } }, [
        _c(
          "div",
          { staticClass: "home_box_center home_warp_one" },
          [
            _vm.bannerData.length > 0
              ? _c(
                  "zswiper",
                  { staticClass: "home_one_item", attrs: { type: "card" } },
                  _vm._l(_vm.bannerData, function (item, index) {
                    return _c("zswiper-item", { key: index }, [
                      _c(
                        "a",
                        {
                          staticClass: "home_one_bnner",
                          attrs: { href: item.linkUrl, target: "_blank" },
                        },
                        [
                          _c("img", {
                            staticClass: "position_center otherImg",
                            attrs: {
                              title: item.title,
                              src: item.imageUrl,
                              alt: "",
                            },
                          }),
                        ]
                      ),
                    ])
                  }),
                  1
                )
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "home_warp_types" }, [
          _c(
            "div",
            { staticClass: "home_box_center flex_center" },
            _vm._l(_vm.typesList, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "home_types_list flex_center",
                  on: {
                    click: function ($event) {
                      return _vm.toLink(item)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "types_list_head flex_center" }, [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/newimg/types_" +
                          item.type +
                          ".png"),
                        alt: "",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("div", { staticClass: "types_list_title" }, [
                      _vm._v(_vm._s(item.name)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "types_list_txt" }, [
                      _vm._v(_vm._s(item.txt)),
                    ]),
                  ]),
                ]
              )
            }),
            0
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "home_warp_promote" }, [
        _c(
          "div",
          { staticClass: "home_box_center flex_base" },
          [
            _c(
              "el-carousel",
              {
                ref: "remarkCarusel",
                staticClass: "home_promote_left",
                attrs: {
                  height: "100%",
                  direction: "vertical",
                  "indicator-position": "none",
                },
                on: { change: _vm.lisChange },
              },
              _vm._l(_vm.homeNavList, function (item, index) {
                return _c(
                  "el-carousel-item",
                  { key: index },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "promote_left_item",
                        attrs: {
                          to: {
                            path: item.url,
                            query:
                              item.type === "2"
                                ? { pushObjectId: item.id, courseType: "14" }
                                : { pushObjectId: item.id },
                          },
                        },
                      },
                      [
                        _c("img", {
                          staticClass: "promote_left_bg",
                          attrs: {
                            src: require("@/assets/newimg/pr_left/pr_bg_" +
                              index +
                              ".png"),
                            alt: "",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "promote_left_bg promote_left_mask" },
                          [
                            _c("div", { staticClass: "promote_left_title" }, [
                              _vm._v(_vm._s(item.name)),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flex_base" },
                              _vm._l(
                                item.resourceTypeTotal,
                                function (child, ii) {
                                  return _c(
                                    "div",
                                    { key: ii, staticClass: "left_list" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "left_list_num" },
                                        [_vm._v(_vm._s(child.total))]
                                      ),
                                      _vm._v(" "),
                                      _c("span", [_vm._v(_vm._s(child.name))]),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "box_2_but " }, [
                              _vm._v(
                                "\n                  开始探索\n                  "
                              ),
                              _c("img", {
                                staticClass: "box_2_play",
                                attrs: {
                                  src: require("@/assets/newimg/pr_left/play_w.png"),
                                },
                              }),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ],
                  1
                )
              }),
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "home_promote_right" },
              _vm._l(_vm.homeNavList, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "promote_right_item",
                    class: { is_active: index === _vm.isActive },
                    on: {
                      click: function ($event) {
                        return _vm.lisChange(index)
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "right_item_dit" }),
                    _vm._v(
                      "\n              " + _vm._s(item.name) + "\n            "
                    ),
                  ]
                )
              }),
              0
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "home_box home_warp_two", attrs: { id: "three" } },
        [
          _c("div", { staticClass: "home_rank_title color_black" }, [
            _vm._v("嗨，你从事什么职业呢？"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "home_rank_text color_gray" }, [
            _vm._v(
              "\n      职业是参与社会分工，利用专门的知识和技能，为社会创造物质财富和精神财富，获取合理报酬，作为物质生活来源，并满足精神需求的工作。\n    "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "home_box_center2" }, [
            _c(
              "div",
              { staticClass: "home_two_left flex_between" },
              _vm._l(_vm.twoData.slice(0, 4), function (item) {
                return _c(
                  "router-link",
                  {
                    key: item.id,
                    staticClass: "flex_top",
                    attrs: {
                      to: {
                        path: "/virtual",
                        query: {
                          id: item.id,
                          occupationCategory: item.name,
                          courseType: "14",
                        },
                      },
                    },
                  },
                  [
                    _c("span", [_vm._v(_vm._s(item.name))]),
                    _vm._v(" "),
                    _c("div", { staticClass: "home_two_icon" }, [
                      _c("div", { staticClass: "home_two_inset flex_center" }, [
                        _c("img", { attrs: { src: item.icon } }),
                      ]),
                    ]),
                  ]
                )
              }),
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "home_two_center" }, [
              _c("div", { staticClass: "two_center_text" }, [
                _c("div", { staticClass: "two_center_num" }, [
                  _vm._v(_vm._s(_vm.resourceTotal)),
                ]),
                _vm._v("\n          职业资源数量\n        "),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "home_two_right flex_between" },
              _vm._l(_vm.twoData.slice(4, 8), function (item) {
                return _c(
                  "router-link",
                  {
                    key: item.id,
                    staticClass: "flex_top",
                    attrs: {
                      to: {
                        path: "/virtual",
                        query: {
                          id: item.id,
                          occupationCategory: item.name,
                          courseType: "14",
                        },
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "home_two_icon" }, [
                      _c("div", { staticClass: "home_two_inset flex_center" }, [
                        _c("img", { attrs: { src: item.icon } }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(item.name))]),
                  ]
                )
              }),
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "home_box home_warp_three", attrs: { id: "four" } },
        [
          _c(
            "div",
            { staticClass: "home_rank_title color_black home_three_title" },
            [_vm._v("\n      您是哪个行业的？\n    ")]
          ),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _c(
            "section",
            { staticClass: "home_box_center home_three_body" },
            [
              _vm.industryData.length > 0
                ? _c(
                    "el-carousel",
                    {
                      ref: "carousel",
                      staticClass: "home_three_carousel",
                      attrs: { trigger: "click", arrow: "never" },
                    },
                    _vm._l(_vm.industryData, function (item, index) {
                      return _c("el-carousel-item", { key: index }, [
                        _c(
                          "div",
                          { staticClass: "home_three_ul flex_between" },
                          _vm._l(item, function (product, productid) {
                            return _c(
                              "router-link",
                              {
                                key: productid,
                                staticClass: "home_three_item",
                                attrs: {
                                  to: {
                                    path: "/virtual",
                                    query: { courseType: "14" },
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "home_three_imgbox" },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: require("@/assets/newimg/home_three/three_icon_" +
                                          (productid + 1) +
                                          ".png"),
                                        alt: "",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "img_mask flex_center" },
                                      [
                                        _c("span", [
                                          _vm._v(_vm._s(product.count)),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "home_three_title",
                                    attrs: {
                                      title: product.industryDetailName,
                                    },
                                  },
                                  [_vm._v(_vm._s(product.industryDetailName))]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "home_three_icon" }),
                              ]
                            )
                          }),
                          1
                        ),
                      ])
                    }),
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "home_box home_warp_four", attrs: { id: "five" } },
        [
          _c("div", { staticClass: "home_rank_title color_black" }, [
            _vm._v("想学习的专业来这里"),
          ]),
          _vm._v(" "),
          _vm._m(2),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "home_four" },
            [
              _vm.majorData.length > 0
                ? _c(
                    "el-carousel",
                    {
                      ref: "carousel",
                      staticClass: "home_four_carousel",
                      attrs: { trigger: "click", arrow: "never" },
                    },
                    _vm._l(_vm.majorData, function (item, index) {
                      return _c("el-carousel-item", { key: index }, [
                        _c("div", { staticClass: "home_four_ul" }, [
                          _c(
                            "div",
                            { staticClass: "home_four_bg flex_center" },
                            _vm._l(item, function (type, tindex) {
                              return _c(
                                "router-link",
                                {
                                  key: tindex,
                                  staticClass: "home_four_item",
                                  attrs: {
                                    to: {
                                      path: "/virtual",
                                      query: {
                                        courseType: "14",
                                        majorName: type.majorName,
                                      },
                                    },
                                  },
                                },
                                [
                                  _c("img", {
                                    staticClass: "home_four_icon isShow",
                                    attrs: {
                                      src: require("@/assets/newimg/four_tool/icons_" +
                                        type.tindex +
                                        ".png"),
                                      alt: "",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("img", {
                                    staticClass: "home_four_icon isShowh",
                                    attrs: {
                                      src: require("@/assets/newimg/four_tool/icons_" +
                                        type.tindex +
                                        "h.png"),
                                      alt: "",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "home_four_name" }, [
                                    _vm._v(_vm._s(type.majorName)),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "img_mask" }),
                                ]
                              )
                            }),
                            1
                          ),
                        ]),
                      ])
                    }),
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "home_warp_ntwo", attrs: { id: "two" } }, [
        _c("div", { staticClass: "home_rank_title color_black" }, [
          _vm._v("\n      专题\n    "),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "warp_ntwo_center flex_between" },
          _vm._l(_vm.ntwoData, function (item, index) {
            return _c(
              "div",
              {
                key: item.id,
                staticClass: "home_ntwo_item",
                on: {
                  click: function ($event) {
                    return _vm.clickZt(item)
                  },
                },
              },
              [
                _c("img", {
                  staticClass: "ntwo_bg",
                  attrs: {
                    src: require("@/assets/newimg/module/icon_" +
                      item.id +
                      ".png"),
                    alt: "",
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "home_ntwo_title" }, [
                  _c("span", [_vm._v(_vm._s(item.eduLevel))]),
                  _vm._v(" "),
                  _c("div", { attrs: { title: item.resourceData } }, [
                    _vm._v(_vm._s(item.resourceData)),
                  ]),
                ]),
                _vm._v(" "),
                _vm._m(3, true),
              ]
            )
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "home_box home_warp_five", attrs: { id: "six" } },
        [
          _c("div", { staticClass: "home_box_center" }, [
            _c(
              "div",
              { staticClass: "flex_base" },
              [
                _vm._m(4),
                _vm._v(" "),
                _vm._l(_vm.resType.slice(0, 3), function (item, index) {
                  return _c(
                    "div",
                    {
                      key: item.id,
                      staticClass: "box_2_list a_scale",
                      style: {
                        background:
                          "url(" +
                          require("@/assets/newimg/five_icon/" +
                            item.id +
                            ".png") +
                          ")",
                      },
                      attrs: {
                        to: { path: "/", query: { resourceTypeId: item.id } },
                      },
                      on: {
                        click: function ($event) {
                          return _vm.goNext5(item)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "flex_top" }, [
                        _c("span", { staticClass: "flex_center" }, [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/newimg/five_icon/icon_zylx0" +
                                item.id +
                                ".png"),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c("div", { staticClass: "box_2_title" }, [
                            _vm._v(_vm._s(item.name)),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "box_2_num" }, [
                            _vm._v(_vm._s(item.count)),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "box_2_body" }, [
                        _c("div", { staticClass: "box_2_txt" }, [
                          _vm._v(_vm._s(item.text)),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "box_2_link" }, [
                          _vm._v("去看看   →"),
                        ]),
                      ]),
                    ]
                  )
                }),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex_base five_bt" },
              _vm._l(_vm.resType.slice(3, 6), function (item, index) {
                return _c(
                  "div",
                  {
                    key: item.id,
                    staticClass: "box_2_list a_scale",
                    style: {
                      background:
                        "url(" +
                        require("@/assets/newimg/five_icon/" +
                          item.id +
                          ".png") +
                        ")",
                    },
                    attrs: {
                      to: { path: "/", query: { resourceTypeId: item.id } },
                    },
                    on: {
                      click: function ($event) {
                        return _vm.goNext5(item)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "flex_top" }, [
                      _c("span", { staticClass: "flex_center" }, [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/newimg/five_icon/icon_zylx0" +
                              item.id +
                              ".png"),
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("div", { staticClass: "box_2_title" }, [
                          _vm._v(_vm._s(item.name)),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "box_2_num" }, [
                          _vm._v(_vm._s(item.count)),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "box_2_body" }, [
                      _c("div", { staticClass: "box_2_txt" }, [
                        _vm._v(_vm._s(item.text)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "box_2_link" }, [
                        _vm._v("去看看   →"),
                      ]),
                    ]),
                  ]
                )
              }),
              0
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "gjzq_wrapper" }, [
        _c("img", {
          staticClass: "gjzq_img",
          staticStyle: { cursor: "pointer" },
          attrs: { src: require("@/assets/home_bg/gjzq.png") },
          on: { click: _vm.goInternational },
        }),
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "nation-edu-entry" }, [
        _c("div", { staticClass: "nation-edu-entry__inner" }, [
          _vm._m(5),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "nation-edu-entry__button",
              attrs: { type: "button" },
              on: { click: _vm.goNationEdu },
            },
            [
              _vm._v("\n        进入国家平台\n        "),
              _c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("→")]),
            ]
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mobile-layout", style: _vm.mobileCssVars },
      [
        _c("mobile-header", {
          attrs: { "user-info": _vm.userInfo },
          on: { login: _vm.toLoginMobile, search: _vm.handleMobileSearch },
        }),
        _vm._v(" "),
        _c("mobile-banner", { attrs: { "banner-data": _vm.bannerData } }),
        _vm._v(" "),
        _c("mobile-user-types", { attrs: { "types-list": _vm.typesList } }),
        _vm._v(" "),
        _c("mobile-quick-service", { attrs: { "nav-list": _vm.homeNavList } }),
        _vm._v(" "),
        _c("mobile-occupation", { attrs: { "two-data": _vm.twoData } }),
        _vm._v(" "),
        _c("mobile-industry", { attrs: { "industry-data": _vm.industryData } }),
        _vm._v(" "),
        _c("mobile-major-cat", { attrs: { "major-data": _vm.majorData } }),
        _vm._v(" "),
        _c("mobile-special", { attrs: { "ntwo-data": _vm.ntwoData } }),
        _vm._v(" "),
        _c("mobile-resource", {
          attrs: { "res-type": _vm.resType },
          on: { "go-next": _vm.goNext5 },
        }),
        _vm._v(" "),
        _c("mobile-international-entry"),
        _vm._v(" "),
        _c("mobile-footer", { on: { "go-nation": _vm.goNationEdu } }),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "home_warp_zhzj" }, [
      _c("img", { attrs: { src: require("@/assets/home_bg/zhzj.png") } }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "home_rank_text color_gray home_three_text" },
      [
        _vm._v("\n      以此士之进退，多言命运，而不言行业\n      "),
        _c("br"),
        _vm._v(
          "大概其学术行业，恢奇漭瀁，适於致用，然欲以辙求之，又不得也\n    "
        ),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "home_rank_text color_gray" }, [
      _vm._v("\n      丰富的课程资源\n      "),
      _c("br"),
      _vm._v("为老师、学生提供风格的选择\n    "),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ntwo_bnts flex_center" }, [
      _vm._v("\n          开始学习\n          "),
      _c("img", { attrs: { src: require("@/assets/newimg/play.png") } }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box_2_left" }, [
      _c("div", { staticClass: "c_rank_title color_black" }, [
        _vm._v("想要的资源来这里"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "c_rank_text color_gray" }, [
        _vm._v("\n              丰富的课程资源\n              "),
        _c("br"),
        _vm._v("为老师、学生提供风格的选择\n            "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "box_2_but flex_center" }, [
        _vm._v("\n              开始探索\n              "),
        _c("img", {
          staticClass: "box_2_play",
          attrs: { src: require("@/assets/newimg/play_b.png") },
        }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "nation-edu-entry__title" }, [
        _vm._v("国家智慧教育公共服务平台"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }